module.exports = __webpack_public_path__ + "img/introductionGreen.a800ddfb.jpg";